import { apiClient } from "../api/apiClient.js";

/**
 * Thin fetch wrappers over the Prompt 089R Agent Invite Card API. Every
 * function takes agentId explicitly (never reads it from anywhere global)
 * so a caller can never accidentally call these without first resolving a
 * real owning-Agent id via ownership.js.
 */

export function listInviteCards(agentId, { page = 1, pageSize = 100 } = {}) {
  const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
  return apiClient.get(`/backoffice/agents/${encodeURIComponent(agentId)}/invite-cards?${params.toString()}`);
}

export function createInviteCard(agentId, payload) {
  return apiClient.post(`/backoffice/agents/${encodeURIComponent(agentId)}/invite-cards`, payload);
}

export function getInviteCard(agentId, inviteCardId) {
  return apiClient.get(
    `/backoffice/agents/${encodeURIComponent(agentId)}/invite-cards/${encodeURIComponent(inviteCardId)}`
  );
}

/**
 * The Agent's ONE standing invite link, fetched or created in a single call.
 * This is what the Agents list's "คัดลอกลิงก์เชิญ" button uses so a SuperAdmin
 * can send an invite for an Agent without opening the create form first.
 *
 * POST because it may insert a card - but it is idempotent for the caller: the
 * same agentId always resolves to the same link, and calling it twice never
 * mints a second card. Callers may therefore call it on every button press
 * rather than caching the result.
 */
export function ensureStandingInviteLink(agentId) {
  return apiClient.post(
    `/backoffice/agents/${encodeURIComponent(agentId)}/invite-cards/standing-link`,
    {}
  );
}

export function revokeInviteCard(agentId, inviteCardId) {
  return apiClient.post(
    `/backoffice/agents/${encodeURIComponent(agentId)}/invite-cards/${encodeURIComponent(inviteCardId)}/revoke`,
    {}
  );
}
